export class UsuarioDTO {
    nombresCompletos:string;
    dni:string;
    email:string;
}